import { type ReactNode } from 'react';
import { ConfirmButtons } from './creator-delete-confirm';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  isPending: boolean;
};

export function CreatorHardDeleteConfirm({
  onConfirm,
  onCancel,
  isPending,
}: Props): ReactNode {
  return (
    <div className="flex flex-col gap-sm border-t border-white/[0.06] pt-base">
      <p className="text-xs text-brand-red">
        Acción irreversible. Se borrará el registro y se perderá toda
        trazabilidad (collector, fecha, motivo de eliminación).
      </p>
      <ConfirmButtons
        onCancel={onCancel}
        onConfirm={onConfirm}
        isPending={isPending}
        label="Eliminar permanentemente"
        variant="danger"
      />
    </div>
  );
}
